function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useContext, useState, useRef } from "react";
import { useUIDSeed } from "react-uid";
import { ImageContext } from "../../../context";
import { twMerge } from "../../../utils";
import { Section } from "../../molecules";
import { ImageLightbox } from "../ImageLightbox";
export function HorizontalMasonryGallery(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "scale" : _variant, images = param.images, enableLines = param.enableLines, className = param.className;
    var seed = useUIDSeed();
    var lightboxRef = useRef(null);
    var ref = _slicedToArray(useState(false), 2), lightboxOpen = ref[0], setLightBoxOpen = ref[1];
    var ref1 = _slicedToArray(useState(0), 2), defaultIndex = ref1[0], setDefaultIndex = ref1[1];
    var ImageComponent = useContext(ImageContext).ImageComponent;
    var allImages = images.reduce(function(acc, row) {
        return acc.concat(row.map(function(image) {
            return image.image;
        }));
    }, []);
    var handleOpenLightbox = function(entry) {
        var ref;
        var index = allImages.findIndex(function(image) {
            return image === entry.image;
        });
        setDefaultIndex(index);
        (ref = lightboxRef.current) === null || ref === void 0 ? void 0 : ref.setActiveIndex(index);
        setLightBoxOpen(true);
    };
    var handleCloseLightbox = function() {
        setLightBoxOpen(false);
    };
    return /*#__PURE__*/ React.createElement(Section, {
        lines: enableLines ? "dark" : false,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative container grid grid-cols-1 grid-flow-row auto-rows-min gap-4 md:gap-5"
    }, images.map(function(row) {
        var keys = row.map(function(entry) {
            return entry.key || seed(entry.image);
        });
        var aspectRatios = row.map(function(entry) {
            return entry.image.width / entry.image.height;
        });
        var combinedKey = keys.join("-");
        return /*#__PURE__*/ React.createElement("div", {
            key: combinedKey,
            className: twMerge("grid gap-4 grid-cols-1 md:gap-5", variant === "scale" && "grid-cols-[var(--tw-grid-cols)]", variant === "mobile-stacked" && "md:grid-cols-[var(--tw-grid-cols)]"),
            style: {
                "--tw-grid-cols": aspectRatios.map(function(ratio) {
                    return "".concat(ratio, "fr");
                }).join(" ")
            }
        }, row.map(function(entry, entryIndex) {
            return /*#__PURE__*/ React.createElement("button", {
                key: keys[entryIndex],
                type: "button",
                onClick: function() {
                    return handleOpenLightbox(entry);
                }
            }, /*#__PURE__*/ React.createElement(ImageComponent, _extends({}, entry.image)));
        }));
    })), /*#__PURE__*/ React.createElement(ImageLightbox, {
        ref: lightboxRef,
        defaultIndex: defaultIndex,
        open: lightboxOpen,
        images: allImages,
        onClose: handleCloseLightbox
    }));
}

//# sourceMappingURL=HorizontalMasonryGallery.js.map